const actions = {
  GENERATE_COUPON_BEGIN: "GENERATE_COUPON_BEGIN",
  GENERATE_COUPON_SUCCESS: "GENERATE_COUPON_SUCCESS",
  GENERATE_COUPON_ERR: "GENERATE_COUPON_ERR",
  GENERATE_COUPON_RESET: "GENERATE_COUPON_RESET",

  GET_COUPON_DETAILS_BEGIN: "GET_COUPON_DETAILS_BEGIN",
  GET_COUPON_DETAILS_SUCCESS: "GET_COUPON_DETAILS_SUCCESS",
  GET_COUPON_DETAILS_ERR: "GET_COUPON_DETAILS_ERR",
  GET_COUPON_DETAILS_RESET: "GET_COUPON_DETAILS_RESET",

  OFFER_PRODUCT_LIST_BEGIN: "OFFER_PRODUCT_LIST_BEGIN",
  OFFER_PRODUCT_LIST_SUCCESS: "OFFER_PRODUCT_LIST_SUCCESS",
  OFFER_PRODUCT_LIST_ERR: "OFFER_PRODUCT_LIST_ERR",
  OFFER_PRODUCT_LIST_RESET: "OFFER_PRODUCT_LIST_RESET",

  COUPON_HISTORY_BEGIN: "COUPON_HISTORY_BEGIN",
  COUPON_HISTORY_SUCCESS: "COUPON_HISTORY_SUCCESS",
  COUPON_HISTORY_ERR: "COUPON_HISTORY_ERR",
  COUPON_HISTORY_RESET: "COUPON_HISTORY_RESET",

  COUPON_DETAILS_BEGIN: "COUPON_DETAILS_BEGIN",
  COUPON_DETAILS_SUCCESS: "COUPON_DETAILS_SUCCESS",
  COUPON_DETAILS_ERR: "COUPON_DETAILS_ERR",
  COUPON_DETAILS_RESET: "COUPON_DETAILS_RESET",

  generateCouponBegin: () => ({
    type: actions.GENERATE_COUPON_BEGIN,
  }),

  generateCouponSuccess: (data) => ({
    type: actions.GENERATE_COUPON_SUCCESS,
    data,
  }),

  generateCouponErr: (err) => ({
    type: actions.GENERATE_COUPON_ERR,
    err,
  }),

  generateCouponReset: () => ({
    type: actions.GENERATE_COUPON_RESET,
  }),

  getRefDetailsBegin: () => ({
    type: actions.GET_COUPON_DETAILS_BEGIN,
  }),

  getRefDetailsSuccess: (data) => ({
    type: actions.GET_COUPON_DETAILS_SUCCESS,
    data,
  }),

  getRefDetailsErr: (err) => ({
    type: actions.GET_COUPON_DETAILS_ERR,
    err,
  }),

  getRefDetailsReset: () => ({
    type: actions.GET_COUPON_DETAILS_RESET,
  }),

  getOfferProductListBegin: () => ({
    type: actions.OFFER_PRODUCT_LIST_BEGIN,
  }),

  getOfferProductListSuccess: (data) => ({
    type: actions.OFFER_PRODUCT_LIST_SUCCESS,
    data,
  }),

  getOfferProductListErr: (err) => ({
    type: actions.OFFER_PRODUCT_LIST_ERR,
    err,
  }),

  getOfferProductListReset: () => ({
    type: actions.OFFER_PRODUCT_LIST_RESET,
  }),

  getCouponHistoryBegin: () => ({
    type: actions.COUPON_HISTORY_BEGIN,
  }),

  getCouponHistorySuccess: (data) => ({
    type: actions.COUPON_HISTORY_SUCCESS,
    data,
  }),

  getCouponHistoryErr: (err) => ({
    type: actions.COUPON_HISTORY_ERR,
    err,
  }),

  getCouponHistoryReset: () => ({
    type: actions.COUPON_HISTORY_RESET,
  }),

  getCouponDetailsBegin: () => ({
    type: actions.COUPON_DETAILS_BEGIN,
  }),

  getCouponDetailsSuccess: (data) => ({
    type: actions.COUPON_DETAILS_SUCCESS,
    data,
  }),

  getCouponDetailsErr: (err) => ({
    type: actions.COUPON_DETAILS_ERR,
    err,
  }),

  getCouponDetailsReset: () => ({
    type: actions.COUPON_DETAILS_RESET,
  }),
};
export default actions;
